/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Back_To_ResumesInputs */

const en_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to resumes`)
};

const de_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Lebensläufen`)
};

const fr_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour aux CV`)
};

const es_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a currículums`)
};

const it_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna ai curriculum`)
};

const nl_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar CV's`)
};

const pl_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do CV`)
};

const fi_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin ansioluetteloihin`)
};

const da_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til CV'er`)
};

const sv_resumes_back_to_resumes = /** @type {(inputs: Resumes_Back_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till CV:n`)
};

/**
* | output |
* | --- |
* | "Back to resumes" |
*
* @param {Resumes_Back_To_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_back_to_resumes = /** @type {((inputs?: Resumes_Back_To_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Back_To_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_back_to_resumes(inputs)
	if (locale === "fr") return fr_resumes_back_to_resumes(inputs)
	if (locale === "es") return es_resumes_back_to_resumes(inputs)
	if (locale === "it") return it_resumes_back_to_resumes(inputs)
	if (locale === "nl") return nl_resumes_back_to_resumes(inputs)
	if (locale === "pl") return pl_resumes_back_to_resumes(inputs)
	if (locale === "fi") return fi_resumes_back_to_resumes(inputs)
	if (locale === "da") return da_resumes_back_to_resumes(inputs)
	if (locale === "sv") return sv_resumes_back_to_resumes(inputs)
	return en_resumes_back_to_resumes(inputs)
});